<template>
  <div id="LayoutMain">
    <router-view />
    <TopBar />
    <!-- <Footer /> -->
  </div>
</template>

<script>
// import Footer from '../components/navigation/Footer'
import TopBar from '../components/navigation/TopBar'

export default {
  components: {
    // Footer,
    TopBar,
  },
}
</script>

<style lang="scss">
#LayoutMain {
  margin-top: $topbar-height-compact;
  @include md {
    margin-top: $topbar-height;
  }
}
</style>
